import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEnum from "../Data.Enum/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFormURLEncoded from "../Data.FormURLEncoded/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Data$dUnfoldable1 from "../Data.Unfoldable1/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dJSON from "../Foreign.JSON/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Data$dOrd.ordString)(Data$dFoldable.foldableArray);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe))();
const toParamJSON = dictEncode => Foreign$dGeneric.encodeJSON(dictEncode);
const toParam = dict => dict.toParam;
const toParamWrapped = () => dictAsParam => x => dictAsParam.toParam(x);
const renderURL = v => {
  if (v.params.tag === "Leaf") { return v.path; }
  const $0 = Data$dFormURLEncoded.encode(Data$dFunctor.arrayMap(Data$dTuple.functorTuple.map(Data$dMaybe.Just))(toUnfoldable(v.params)));
  if ($0.tag === "Nothing") { return v.path + "?"; }
  if ($0.tag === "Just") { return v.path + "?" + $0._1; }
  $runtime.fail();
};
const recordToParamsNil = {recordToParams: v => v1 => Data$dMap$dInternal.Leaf};
const recordToParams = dict => dict.recordToParams;
const recordToParamsCons = dictIsSymbol => dictAsParam => () => dictRecordToParams => (
  {
    recordToParams: v => r => Data$dMap$dInternal.insert(Data$dOrd.ordString)(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(dictAsParam.toParam(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(r)))(dictRecordToParams.recordToParams(Type$dProxy.Proxy)(r))
  }
);
const recordToParamsConsMb = dictIsSymbol => dictAsParam => () => dictRecordToParams => (
  {
    recordToParams: v => r => {
      const v1 = Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(r);
      if (v1.tag === "Nothing") { return dictRecordToParams.recordToParams(Type$dProxy.Proxy)(r); }
      if (v1.tag === "Just") {
        return Data$dMap$dInternal.insert(Data$dOrd.ordString)(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(dictAsParam.toParam(v1._1))(dictRecordToParams.recordToParams(Type$dProxy.Proxy)(r));
      }
      $runtime.fail();
    }
  }
);
const recordFromParamsNil = {recordFromParams: v => v1 => Data$dMaybe.$Maybe("Just", {})};
const recordFromParams = dict => dict.recordFromParams;
const genericToParams = dict => dict.genericToParams;
const genericToExpandedURL = dict => dict.genericToExpandedURL;
const genericToURL = dictGeneric => dictGenericAsURL => x => renderURL(dictGenericAsURL.genericToExpandedURL(dictGeneric.from(x)));
const genericFromParams = dict => dict.genericFromParams;
const genericFromExpandedURL = dict => dict.genericFromExpandedURL;
const genericAsURLSum = dictGenericAsURL => dictGenericAsURL1 => (
  {
    genericFromExpandedURL: url => {
      const $0 = dictGenericAsURL.genericFromExpandedURL(url);
      const $1 = $0.tag === "Just" ? Data$dMaybe.$Maybe("Just", Data$dGeneric$dRep.$Sum("Inl", $0._1)) : Data$dMaybe.Nothing;
      const $2 = dictGenericAsURL1.genericFromExpandedURL(url);
      const $3 = $2.tag === "Just" ? Data$dMaybe.$Maybe("Just", Data$dGeneric$dRep.$Sum("Inr", $2._1)) : Data$dMaybe.Nothing;
      if ($1.tag === "Nothing") { return $3; }
      return $1;
    },
    genericToExpandedURL: v => {
      if (v.tag === "Inl") { return dictGenericAsURL.genericToExpandedURL(v._1); }
      if (v.tag === "Inr") { return dictGenericAsURL1.genericToExpandedURL(v._1); }
      $runtime.fail();
    }
  }
);
const genericAsURLConstructor = dictIsSymbol => dictGenericAsParams => (
  {
    genericFromExpandedURL: v => {
      if (v.path === dictIsSymbol.reflectSymbol(Type$dProxy.Proxy)) {
        const $0 = dictGenericAsParams.genericFromParams(v.params);
        if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
        return Data$dMaybe.Nothing;
      }
      return Data$dMaybe.Nothing;
    },
    genericToExpandedURL: v => ({path: dictIsSymbol.reflectSymbol(Type$dProxy.Proxy), params: dictGenericAsParams.genericToParams(v)})
  }
);
const genericAsParamsRecord = () => dictRecordFromParams => dictRecordToParams => (
  {
    genericFromParams: p => {
      const $0 = dictRecordFromParams.recordFromParams(Type$dProxy.Proxy)(p);
      if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
      return Data$dMaybe.Nothing;
    },
    genericToParams: v => dictRecordToParams.recordToParams(Type$dProxy.Proxy)(v)
  }
);
const genericAsParamsNoArguments = {genericFromParams: v => Data$dMaybe.$Maybe("Just", Data$dGeneric$dRep.NoArguments), genericToParams: v => Data$dMap$dInternal.Leaf};
const fromParamJSON = dictDecode => {
  const $0 = Foreign$dJSON.decodeJSONWith(dictDecode.decode);
  return x => {
    const $1 = $0(x);
    if ($1.tag === "Left") { return Data$dMaybe.Nothing; }
    if ($1.tag === "Right") { return Data$dMaybe.$Maybe("Just", $1._1); }
    $runtime.fail();
  };
};
const fromParam = dict => dict.fromParam;
const fromParamWrapped = () => dictAsParam => p => {
  const $0 = dictAsParam.fromParam(p);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
  return Data$dMaybe.Nothing;
};
const genericAsParamsSingleArg = dictAsParam => (
  {
    genericFromParams: p => {
      const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)("_")(p);
      if ($0.tag === "Just") {
        const $1 = dictAsParam.fromParam($0._1);
        if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", $1._1); }
        return Data$dMaybe.Nothing;
      }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    },
    genericToParams: v => Data$dMap$dInternal.$$$Map("Node", 1, 1, "_", dictAsParam.toParam(v), Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf)
  }
);
const genericAsParamsSingleArgMb = dictAsParam => (
  {
    genericFromParams: p => {
      const rawValue = Data$dMap$dInternal.lookup(Data$dOrd.ordString)("_")(p);
      if (rawValue.tag === "Just") {
        const $0 = dictAsParam.fromParam(rawValue._1);
        if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dMaybe.$Maybe("Just", $0._1)); }
        return Data$dMaybe.Nothing;
      }
      if (rawValue.tag === "Nothing") { return Data$dMaybe.$Maybe("Just", Data$dMaybe.Nothing); }
      $runtime.fail();
    },
    genericToParams: v => {
      if (v.tag === "Just") { return Data$dMap$dInternal.$$$Map("Node", 1, 1, "_", dictAsParam.toParam(v._1), Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf); }
      if (v.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
      $runtime.fail();
    }
  }
);
const recordFromParamsCons = dictIsSymbol => dictAsParam => () => () => dictRecordFromParams => (
  {
    recordFromParams: v => p => {
      const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(p);
      if ($0.tag === "Just") {
        const $1 = dictAsParam.fromParam($0._1);
        if ($1.tag === "Just") {
          const $2 = dictRecordFromParams.recordFromParams(Type$dProxy.Proxy)(p);
          if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))($1._1)($2._1)); }
          if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        }
        if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    }
  }
);
const recordFromParamsConsMb = dictIsSymbol => dictAsParam => () => () => dictRecordFromParams => (
  {
    recordFromParams: v => p => {
      const rawValue = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(p);
      if (rawValue.tag === "Just") {
        const $0 = dictAsParam.fromParam(rawValue._1);
        if ($0.tag === "Just") {
          const $1 = dictRecordFromParams.recordFromParams(Type$dProxy.Proxy)(p);
          if ($1.tag === "Just") {
            return Data$dMaybe.$Maybe("Just", Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(Data$dMaybe.$Maybe("Just", $0._1))($1._1));
          }
          if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        }
        return Data$dMaybe.Nothing;
      }
      if (rawValue.tag === "Nothing") {
        const $0 = dictRecordFromParams.recordFromParams(Type$dProxy.Proxy)(p);
        if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(Data$dMaybe.Nothing)($0._1)); }
        if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      }
      $runtime.fail();
    }
  }
);
const expandURL = s => {
  const v = Data$dArray.unconsImpl(v => Data$dMaybe.Nothing, x => xs => Data$dMaybe.$Maybe("Just", {head: x, tail: xs}), Data$dString$dCommon.split("?")(s));
  if (v.tag === "Nothing") { return {path: "", params: Data$dMap$dInternal.Leaf}; }
  if (v.tag === "Just") {
    return {
      path: v._1.head,
      params: fromFoldable(Data$dFunctor.arrayMap(m => Data$dTuple.$Tuple(
        m._1,
        (() => {
          if (m._2.tag === "Nothing") { return ""; }
          if (m._2.tag === "Just") { return m._2._1; }
          $runtime.fail();
        })()
      ))((() => {
        const $0 = Data$dFormURLEncoded.decode(Data$dString$dCommon.joinWith("?")(v._1.tail));
        if ($0.tag === "Nothing") { return []; }
        if ($0.tag === "Just") { return $0._1; }
        $runtime.fail();
      })()))
    };
  }
  $runtime.fail();
};
const genericFromURL = dictGeneric => dictGenericAsURL => x => {
  const $0 = dictGenericAsURL.genericFromExpandedURL(expandURL(x));
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", dictGeneric.to($0._1)); }
  return Data$dMaybe.Nothing;
};
const enumToParam = dictShow => dictShow.show;
const enumFromParam = dictShow => dictBounded => {
  const bottom = dictBounded.bottom;
  const top = dictBounded.top;
  return dictEnum => {
    const allEnumValues1 = Data$dEnum.enumFromTo(dictEnum)(Data$dUnfoldable1.unfoldable1Array)(bottom)(top);
    return needle => Data$dFoldable.find(Data$dFoldable.foldableArray)(value => dictShow.show(value) === needle)(allEnumValues1);
  };
};
const asParamUUID = {fromParam: Data$dUUID.fromString, toParam: Data$dUUID.toString};
const asParamInt = {fromParam: Data$dInt.fromString, toParam: Data$dShow.showIntImpl};
const toParamWrapped1 = x => Data$dShow.showIntImpl(x);
const asParamStaffId = {fromParam: /* #__PURE__ */ fromParamWrapped()(asParamInt), toParam: toParamWrapped1};
const asParamTripId = {fromParam: /* #__PURE__ */ fromParamWrapped()(asParamInt), toParam: toParamWrapped1};
const asParamDeliveryJobId = {fromParam: /* #__PURE__ */ fromParamWrapped()(asParamInt), toParam: toParamWrapped1};
const asParamDate = {
  fromParam: d => {
    const $0 = DateUtils.parseISODate(d);
    if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
    return Data$dMaybe.Nothing;
  },
  toParam: x => DateUtils.formatISODate(x)
};
const asParamBool = /* #__PURE__ */ (() => (
  {
    fromParam: s => {
      const v = Data$dString$dCommon.toLower(s);
      if (v === "true") { return Data$dMaybe.$Maybe("Just", true); }
      if (v === "false") { return Data$dMaybe.$Maybe("Just", false); }
      return Data$dMaybe.Nothing;
    },
    toParam: Data$dShow.showBoolean.show
  }
))();
const asParamArray = dictAsParam => {
  const fromParam1 = dictAsParam.fromParam;
  return {
    fromParam: s => traverse(fromParam1)(Data$dString$dCommon.split(",")(s)),
    toParam: (() => {
      const $0 = Data$dString$dCommon.joinWith(",");
      const $1 = Data$dFunctor.arrayMap(dictAsParam.toParam);
      return x => $0($1(x));
    })()
  };
};
export {
  asParamArray,
  asParamBool,
  asParamDate,
  asParamDeliveryJobId,
  asParamInt,
  asParamStaffId,
  asParamTripId,
  asParamUUID,
  enumFromParam,
  enumToParam,
  expandURL,
  fromFoldable,
  fromParam,
  fromParamJSON,
  fromParamWrapped,
  genericAsParamsNoArguments,
  genericAsParamsRecord,
  genericAsParamsSingleArg,
  genericAsParamsSingleArgMb,
  genericAsURLConstructor,
  genericAsURLSum,
  genericFromExpandedURL,
  genericFromParams,
  genericFromURL,
  genericToExpandedURL,
  genericToParams,
  genericToURL,
  recordFromParams,
  recordFromParamsCons,
  recordFromParamsConsMb,
  recordFromParamsNil,
  recordToParams,
  recordToParamsCons,
  recordToParamsConsMb,
  recordToParamsNil,
  renderURL,
  toParam,
  toParamJSON,
  toParamWrapped,
  toParamWrapped1,
  toUnfoldable,
  traverse
};
